import { Link } from "react-router-dom";
import CategoryDropdown from "./CategoryDropdown";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[450px] md:min-h-[580px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20modern%20lifestyle%20product%20photography%20scene%20with%20soft%20natural%20lighting%2C%20warm%20cream%20and%20beige%20tones%2C%20elegant%20composition%20featuring%20curated%20fashion%20accessories%20on%20a%20marble%20surface%2C%20abstract%20editorial%20style%20with%20gentle%20shadows%2C%20airy%20and%20fresh%20atmosphere%2C%20no%20text%2C%20minimal%20aesthetic%2C%20high%20end%20magazine%20photography%20quality&width=1600&height=800&seq=css-hero-bg-01&orientation=landscape"
        alt="CSSBuy Spreadsheet Product Lifestyle Display"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          The Most Updated CSSBuy Spreadsheet 2026
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover verified CSSBuy spreadsheets for shoes, streetwear, and accessories. Compare Kakobuy, Superbuy, and Oopbuy spreadsheets in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            CSSBuy Sheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-lg hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-cart-line"></i>
          </a>
          <Link
            to="/article/cssbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-white/40 text-white font-semibold text-sm rounded-lg hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Read Full Guide
            <i className="ri-article-line"></i>
          </Link>
        </div>

        <div className="flex justify-center mt-6">
          <CategoryDropdown />
        </div>
      </div>
    </section>
  );
}